"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSortSites = void 0;
require("core-js/modules/es.array.sort.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _paulCorePackage = require("paul-core-package");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = require("react");
var _constants = require("../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const sortResValue = {
  more: 1,
  less: -1,
  equals: 0
};
const useSortSites = _ref => {
  let {
    sites,
    sortParams
  } = _ref;
  const tV = (0, _paulCorePackage.useTranslationValue)();
  return (0, _react.useMemo)(() => {
    const entriesOptionLabelParams = Object.entries(sortParams);
    const getNumber = param => Number.isNaN(Number(tV(param))) ? 0 : Number(tV(param));
    const getString = param => tV(param || {}).toUpperCase();
    const getCompare = (type, first, second) => {
      if (type === _constants.valueTypes.string) {
        return getString(first) > getString(second);
      }
      return getNumber(first) > getNumber(second);
    };
    const getCompareSortResult = (type, first, second) => {
      if (getCompare(type, first, second)) {
        return sortResValue.more;
      }
      if (getCompare(type, second, first)) {
        return sortResValue.less;
      }
      return sortResValue.equals;
    };
    if (entriesOptionLabelParams.length === 0) return sites;
    return sites.sort((a, b) => {
      let resultPrevCompare = 0;
      // eslint-disable-next-line no-plusplus
      for (let index = 0; index < entriesOptionLabelParams.length; index++) {
        if (index && resultPrevCompare !== sortResValue.equals) {
          return resultPrevCompare;
        }
        const [paramKey, paramValues] = entriesOptionLabelParams[index];
        resultPrevCompare = getCompareSortResult(paramValues.type, a[paramKey], b[paramKey]);
        if (index === entriesOptionLabelParams.length - 1) {
          return resultPrevCompare;
        }
      }
      return resultPrevCompare;
    });
  }, [sortParams, sites, tV]);
};
exports.useSortSites = useSortSites;
useSortSites.propTypes = {
  sites: _propTypes.default.arrayOf(_propTypes.default.shape({})),
  sortParams: _propTypes.default.shape({
    [_propTypes.default.string]: _propTypes.default.shape({
      type: _propTypes.default.oneOf(Object.values(_constants.valueTypes))
    })
  })
};